import { render } from "./InputMultipleChoice.vue?vue&type=template&id=4d903390"
import script from "./InputMultipleChoice.vue?vue&type=script&lang=js"
export * from "./InputMultipleChoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__